import css from "../../css/find-agent/agents.module.css";

import React from "react";
import PropTypes from "prop-types";
import Link from "next/link";

import Avatar from "../agents/Avatar";
import phoneLinkFormatter from "../../helper/phoneLinkFormatter";
import useMobile from "../../hooks/useMobile";
import AgentRating from "../common/AgentRating";
import { THUMB_150_150 } from "../../service/photo";
import {
    isTeam,
    getNameOfAgentSTeam,
    getTeamAgentProfilePageUrl,
    getTeamProfilePageUrl,
    isForwardTeamLeaderProfileToTeam,
} from "../../service/team_page";

import SealIcon from "mdi-react/SealIcon";
import BullhornOutlineIcon from "mdi-react/BullhornOutlineIcon";

import EnvelopeIcon from "../../static/icons/envelope2.svg";
import PhoneIcon from "../../static/icons/phone.svg";
import TeamPageIcon from "mdi-react/AccountGroupIcon";

const Agent = (props) => {
    const { agent } = props;
    const isMobile = useMobile();

    const { is_featured } = agent;

    const isTeamPage = isTeam(agent);
    const nameOfAgentSTeam = getNameOfAgentSTeam(agent);
    const agentProfilePageUrl = getTeamAgentProfilePageUrl(agent);
    const teamProfilePageUrl = getTeamProfilePageUrl(agent);
    const isForwardTeamLeaderProfileToTeamProfile =
        isForwardTeamLeaderProfileToTeam(agent);

    return (
        <div className={css.agent}>
            <div className={css.photo}>
                {is_featured && <SealIcon className={css.featuredIcon} />}
                <Link
                    href={agentProfilePageUrl.href}
                    as={agentProfilePageUrl.as}
                >
                    <Avatar photo={agent.photo} size={THUMB_150_150} />
                </Link>
                <Link
                    href={agentProfilePageUrl.href}
                    as={agentProfilePageUrl.as}
                    className={css.button}
                >
                    View Profile
                </Link>
                {!isForwardTeamLeaderProfileToTeamProfile &&
                    teamProfilePageUrl && (
                        <div className={css.teamButton}>
                            <Link
                                href={teamProfilePageUrl.href}
                                as={teamProfilePageUrl.as}
                                className={css.buttonTeam}
                            >
                                Team Profile
                            </Link>
                        </div>
                    )}
            </div>
            <div className={css.profile}>
                <div className={css.name}>
                    {isTeamPage ? agent.first_name : agent.full_name}
                </div>
                {isTeamPage && agent.last_name && (
                    <div className={css.teamName2}>{agent.last_name}</div>
                )}
                {isTeamPage && <div className={css.teamInfo}>TEAM</div>}
                {is_featured && (
                    <>
                        {isTeamPage && <div className={css.divider}>|</div>}
                        <div className={css.featuredBadge}>
                            <BullhornOutlineIcon />{" "}
                            <span>Featured Profile</span>
                        </div>
                    </>
                )}
                {agent.office_name && (
                    <div className={css.company}>{agent.office_name}</div>
                )}
                {teamProfilePageUrl && (
                    <div className={css.team} title="TEAM">
                        <Link
                            href={teamProfilePageUrl.href}
                            as={teamProfilePageUrl.as}
                        >
                            <TeamPageIcon /> {nameOfAgentSTeam}
                        </Link>
                    </div>
                )}
                <div className={css.email}>
                    <EnvelopeIcon /> {agent.email}
                </div>
                {agent.phone_primary && (
                    <div className={css.phone}>
                        {isMobile && (
                            <a href={phoneLinkFormatter(agent.phone_primary)}>
                                <PhoneIcon /> {agent.phone_primary}
                            </a>
                        )}
                        {!isMobile && (
                            <>
                                <PhoneIcon /> {agent.phone_primary}
                            </>
                        )}
                    </div>
                )}
                <div className={css.rating}>
                    <AgentRating rating={agent.rating} />
                </div>
            </div>
        </div>
    );
};

Agent.propTypes = {
    agent: PropTypes.object.isRequired
};

export default Agent;
